export const SftpConnection = {
  Success: 0,
  ConnectHostFailed: 1,
  UserLoginFailed: 2,
  Unknown: 3
}
